const toFiniteHealth = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

/**
 * Apply a persisted health response to a character record.
 *
 * MongoDB's authoritative current-HP field is `tempHealth`.  Some map and
 * combat payloads also contain the legacy projection fields `currentHp` and
 * `hpCurrent`; keeping those projections in step prevents them from masking a
 * newer `tempHealth` value when character metrics are calculated.
 */
export const applyPersistedCharacterHealth = (character, update) => {
  if (!character || typeof character !== 'object') {
    return character;
  }

  const responseCharacter =
    update && typeof update === 'object' && update.character && typeof update.character === 'object'
      ? update.character
      : update && typeof update === 'object'
        ? update
        : null;
  const currentHp = toFiniteHealth(
    responseCharacter?.tempHealth ??
      responseCharacter?.currentHp ??
      responseCharacter?.hpCurrent ??
      update
  );

  if (currentHp === null) {
    return character;
  }

  return {
    ...character,
    tempHealth: currentHp,
    currentHp,
    ...(Object.prototype.hasOwnProperty.call(character, 'hpCurrent') ? { hpCurrent: currentHp } : {}),
    ...(responseCharacter?.deathState && typeof responseCharacter.deathState === 'object'
      ? { deathState: responseCharacter.deathState }
      : {}),
  };
};

export default applyPersistedCharacterHealth;
